import { render, staticRenderFns } from "./crudBudget.vue?vue&type=template&id=2a79da17&"
import script from "./crudBudget.vue?vue&type=script&lang=js&"
export * from "./crudBudget.vue?vue&type=script&lang=js&"
import style0 from "./crudBudget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports